module.exports = __webpack_public_path__ + "static/media/Logo-Event.14c2ed96.png";